export default (that) => [
  {
    field: "seq",
    title: "#",
    width: 60,
    align: "center",
    fixed: "left",
    type: "seq",
  },
  {
    title: that.$l("form_label_fabricNo") || "物料编码",
    field: "fabricNo",
    headerAlign: "center",
    align: "center",
    minWidth: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("form_label_fabricName") || "物料名称",
    field: "fabricName",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("form_label_fabricContent") || "规格型号",
    field: "fabricContent",
    headerAlign: "center",
    align: "left",
    minWidth: 200,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("form_label_fabricWidth") || "有效门幅",
    field: "fabricWidth",
    headerAlign: "center",
    align: "center",
    minWidth: 120,
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      const width = row.fabricWidth || "";
      const unit = row.fabricWidthUnit || "";
      return width && unit ? `${width}${unit}` : width || "--";
    },
  },
  {
    title: that.$l("form_label_fabricColor") || "颜色",
    field: "fabricColor",
    headerAlign: "center",
    align: "center",
    minWidth: 120,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("form_label_series") || "系列",
    field: "series",
    headerAlign: "center",
    align: "left",
    minWidth: 120,
    showOverflow: true,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("form_label_fabricWeight") || "克重",
    field: "fabricWeight",
    headerAlign: "center",
    align: "center",
    minWidth: 120,
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      const weight = row.fabricWeight || "";
      const unit = row.fabricWeightUnit || "";
      return weight && unit ? `${weight}${unit}` : weight || "--";
    },
  },
  {
    title: that.$l("form_label_qty") || "数量",
    field: "qty",
    headerAlign: "center",
    align: "center",
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("form_label_fabricUnit") || "单位",
    field: "v_fabricUnit",
    headerAlign: "center",
    align: "center",
    minWidth: 80,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("form_label_unitPrice") || "含税单价",
    field: "unitPrice",
    headerAlign: "center",
    align: "center",
    minWidth: 120,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => {
      return cellValue != null ? Number(cellValue).toFixed(2) : "--";
    },
  },
  {
    title: that.$l("form_label_subAmount") || "价税合计",
    field: "subAmount",
    headerAlign: "center",
    align: "center",
    minWidth: 120,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => {
      return cellValue != null ? Number(cellValue).toFixed(2) : "--";
    },
  },
  {
    title: that.$l("form_label_originOrderNo") || "源头单号",
    field: "originOrderNo",
    headerAlign: "center",
    align: "center",
    minWidth: 150,
    showHeaderOverflow: true,
  },
  {
    title: that.$l("form_label_planArrivalDate") || "计划到货日期",
    field: "planArrivalDate",
    headerAlign: "center",
    align: "center",
    minWidth: 130,
    showHeaderOverflow: true,
  },
];
